export default __webpack_public_path__ + "static/media/lubaantunGrid12.94a52af3.webp";